export default __webpack_public_path__ + "static/media/card-bottom.879bffaf.svg";